/*
 * Copyright (c) 2022. Haodong JU
 */

import { IKDataEntity } from 'metaflow-js'
import hillo from 'hillo'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start',
    },
    form: false,
    header: false,
  },
  // icon: {
  //   displayName: 'icon',
  //   tableConfig: {
  //     overwrite: true,
  //   },
  // },
  name: {
    displayName: 'allergName',
  },

  shortName: {
    displayName: 'shortName',
  },
}
const config = {
  add: function (item) {
    return hillo.postWithUploadFile('Dishes.php?op=addAllergen', item, {
      showLoading: true,
    })
  },
  edit: function (item) {
    return hillo.postWithUploadFile('Dishes.php?op=updateAllergen', item, {
      showLoading: true,
    })
  },
  remove: function (id) {
    return hillo.post('Dishes.php?op=deleteAllergen', { id: id })
  },
  load: async function (filter) {
    return (await hillo.get('Dishes.php', {
      op: 'showAllAllergen',
      ...filter,
    }))
      .content
  },
}

export default IKDataEntity.ModelFactory(entity, config)
